import { get } from "lodash";
import moment from "moment";
import { useMemo } from "react";

export const validate = (values) => {
  const activities = get(values, "activities", []);
  const startDate = moment(get(values, "start_date"));
  const duration = get(values, "duration");
  const minAllowedDate = moment.max([
    get(values, "min_allowed_date"),
    startDate,
  ]);
  const maxAllowedDate = moment.min([
    startDate.clone().add(duration - 1, "month"),
    moment(get(values, "max_allowed_date")),
  ]);
  const months = [];
  const endDate = startDate.clone().add(duration, "months");
  const cursor = startDate.clone();
  while (cursor.isBefore(endDate)) {
    months.push(cursor.format("MM/YYYY"));
    cursor.add(1, "month");
  }
  const plannedMonths = [];
  activities.forEach((activity) => {
    const startDate = moment(get(activity, "start_date"));
    const duration = get(activity, "duration");
    const cursor = startDate.clone();
    const end = cursor.clone().add(duration, "month");
    const activityPlans = [];
    while (cursor.isBefore(end)) {
      const month = cursor.format("MM/YYYY");
      if (plannedMonths.indexOf(month) === -1) {
        plannedMonths.push(month);
      }
      activityPlans.push(month);
      cursor.add(1, "month");
    }
  });
  const empty = months.filter((m) => plannedMonths.indexOf(m) === -1);
  const isFullyPlanned =
    months.length === plannedMonths.length && empty.length === 0;

  const details = {
    startDate,
    // Indica la data minima oltre la quale è possibile pianificare.
    min: minAllowedDate,
    // Indica la data massima entro cui è possibile pianificare.
    max: maxAllowedDate,

    // Indica la durata prevista (previsione) del WP.
    duration,
    // Indica alcune informazioni in merito alla pianificazione.
    planning: {
      // Se è completo, cioè se tutti i mesi previsti hanno effettivamente
      // attività che ne ricoprono il periodo
      completed: isFullyPlanned,
      exceeded: plannedMonths.length > months.length,

      // Indica l'elenco dei mesi non pianificati.
      empty,
      loaded: plannedMonths,
    },
  };
  return details;
};

const isEmpty = (value) =>
  typeof value === "undefined" ||
  value === null ||
  value === "" ||
  (Array.isArray(value) && value.length === 0);

const getMessage = (message, messageArgs, value, values) =>
  typeof message === "function"
    ? message({
        args: messageArgs,
        value,
        values,
      })
    : messageArgs
    ? {
        message,
        args: messageArgs,
      }
    : message;

export const minDate = (message = "ra.validation.minDate") => (
  value,
  values
) => {
  const { min } = validate(values);
  if (isEmpty(value)) {
    return getMessage("ra.validation.required");
  }
  return !moment(value).isSameOrAfter(moment(min).startOf("month"))
    ? getMessage(message, { min: min.format("MM/YYYY") }, value, values)
    : undefined;
};

export const maxDate = (message = "ra.validation.maxDate") => (
  value,
  values
) => {
  const { max } = validate(values);
  if (isEmpty(value)) {
    return getMessage("ra.validation.required");
  }
  return !moment(value).isSameOrBefore(moment(max).startOf("month"))
    ? getMessage(message, { max: max.format("MM/YYYY") }, value, values)
    : undefined;
};
const useValidation = (form) => {
  return useMemo(() => validate(form.values), [form.values]);
};
export default useValidation;
